import React, { createContext, useContext, useMemo } from "react";
import { usePublicProvider } from "../hooks/usePublicProvider";

type RequestRecordsContextValue = ReturnType<typeof usePublicProvider>;

const RequestRecordsContext = createContext<RequestRecordsContextValue | undefined>(undefined);

export function RequestRecordsProvider({ slug, children }: { slug?: string; children: React.ReactNode }) {
  const query = usePublicProvider(slug);
  const value = useMemo(() => query, [query]);
  return <RequestRecordsContext.Provider value={value}>{children}</RequestRecordsContext.Provider>;
}

export function useRequestRecords() {
  const ctx = useContext(RequestRecordsContext);
  if (!ctx) throw new Error("useRequestRecords must be used within RequestRecordsProvider");
  return ctx;
}

